module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.woff?ff94ad94c3a9d04bd2f80cb3c87dcccb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/simple-line-icons/fonts/Simple-Line-Icons.woff
// module id = 601
// module chunks = 0